import EventEmitter from './util/eventEmitter';

/**
 * Esta clase ofrece la posibilidad de crear una variable que al ser
 * actualizada avisa sobre la actualización.
 *
 * @example
 * const name = new WithEventsValue<string>('Alexis Leite');
 *
 * name.on('update', (newName) => console.log(`El nuevo nombre es ${newName}`));
 *
 * name = 'Joel'; // logs "El nuevo nombre es Joel"
 */
export default class WithEventsValue<T> extends EventEmitter<{
  update: T | undefined;
}> {
  #value: T | undefined;

  constructor(value?: T) {
    super();

    this.#value = value;
  }

  get value() {
    return this.#value;
  }

  set value(value: T | undefined) {
    this.#value = value;
    this.emit('update', value);
  }
}
